module.exports = __webpack_public_path__ + "static/media/12.5f676cc1.gif";